import { jsx as _jsx } from "react/jsx-runtime";
import { IndexBackupTypes, IndexType, ExpirationStatus, LicenseMonitoringLevel, ProductEdition, ProductName, ProductType } from "@core/api";
import defaultsDeep from "lodash.defaultsdeep";
import { useMemo } from "react";
import { LicenseContext } from "../contexts/LicenseContext.js";
export var defaultTestLicense = {
    accountId: "batman@waynecorp.com",
    accountName: "Batman",
    department: "WayneCorp R&D",
    expirationDate: 1610647025895,
    expirationStatus: ExpirationStatus.ACTIVE,
    productName: ProductName.COVEO_CLOUD,
    productType: ProductType.TRIAL,
    productEdition: ProductEdition.ENTERPRISE,
    indexBackupType: IndexBackupTypes.NONE,
    indexType: IndexType.COVEO,
    type: "Enterprise",
    properties: {
        content: {
            onPremisesSourcesEnabled: true
        }
    },
    connectors: [],
    entitlements: [],
    monitoringLevel: LicenseMonitoringLevel.NO_MONITORING
};
export var TestLicenseProvider = function(param) {
    var children = param.children, license = param.license;
    var ctx = useMemo(function() {
        return defaultsDeep({}, license, defaultTestLicense);
    }, [
        license
    ]);
    return /*#__PURE__*/ _jsx(LicenseContext.Provider, {
        value: {
            query: {
                data: ctx,
                isLoading: false,
                isSuccess: true,
                isPending: false,
                isError: false,
                status: "success"
            }
        },
        children: children
    });
};

//# sourceMappingURL=TestLicenseProvider.js.map